import { PLATFORM_STATS } from '../constants/platformStats.js';

var getDownloadsFigureTypes;
(function (getDownloadsFigureTypes) {
    getDownloadsFigureTypes[getDownloadsFigureTypes["NUMERIC"] = 0] = "NUMERIC";
    getDownloadsFigureTypes[getDownloadsFigureTypes["THOUSANDS"] = 1] = "THOUSANDS";
    getDownloadsFigureTypes[getDownloadsFigureTypes["MILLIONS"] = 2] = "MILLIONS";
    getDownloadsFigureTypes[getDownloadsFigureTypes["LAKHS"] = 3] = "LAKHS";
    getDownloadsFigureTypes[getDownloadsFigureTypes["LAKH_NUMBER"] = 4] = "LAKH_NUMBER";
})(getDownloadsFigureTypes || (getDownloadsFigureTypes = {}));
const getDownloadsFigure = (type = getDownloadsFigureTypes.LAKHS) => {
    switch (type) {
        case getDownloadsFigureTypes.THOUSANDS:
            return "1000 Thousand+";
        case getDownloadsFigureTypes.MILLIONS:
            return PLATFORM_STATS.appDownloads.millions;
        case getDownloadsFigureTypes.NUMERIC:
            return PLATFORM_STATS.transporters.numeric;
        case getDownloadsFigureTypes.LAKH_NUMBER:
            return `${PLATFORM_STATS.transporters.lakhNumber}`;
        default:
            return PLATFORM_STATS.appDownloads.lakhsLong;
    }
};

export { getDownloadsFigure, getDownloadsFigureTypes };
//# sourceMappingURL=getDownloadsFigure.js.map
